// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

.no-margin {
  margin-left: 0px;
}
.no-margin mat-select {
  padding: 3px !important;
}

.inactiveFlag {
  padding: 0px;
}
.inactiveFlag form {
  display: flex;
  justify-content: right;
}
.inactiveFlag .searchText {
  width: 210px;
}

.tab-header {
  border-bottom: none;
  height: 70px;
  padding-left: 10px;
}

::ng-deep .main-content .content {
  padding: 0px !important;
}

::ng-deep .mat-ripple .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-disabled {
  display: none !important;
}

::ng-deep .mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {
  display: none !important;
}

::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-minimal::after,
.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-minimal::after {
  color: #3e97ff;
}

::ng-deep .mdc-list-item--selected .mdc-list-item__primary-text,
.mdc-list-item--activated .mdc-list-item__primary-text {
  color: #3e97ff;
}

::ng-deep .mat-mdc-select-value-text {
  color: #959cbd;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

::ng-deep .mat-mdc-select-arrow-wrapper {
  display: none !important;
}

.create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  margin: 0px 7px !important;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.create-action img {
  position: relative;
  z-index: 10000;
  margin-bottom: 3px;
  width: 12px;
}

.create-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.create-action:hover::before {
  left: 0;
}

::ng-deep .mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {
  flex-grow: 0 !important;
}

.tab-header ::ng-deep .mat-mdc-tab-link {
  padding: 0 10px;
}

.topClass {
  position: fixed;
  z-index: 10;
  top: 80px;
  min-height: 40px;
  width: 100%;
}

.download {
  margin-left: 8px !important;
}

.allFlags {
  width: 24px;
  margin-left: -3px;
}

.siteClass {
  margin-left: 10px !important;
}

.layout-header {
  background-color: #ffffff;
  overflow-y: hidden;
  margin: 0px !important;
  overflow-x: hidden;
}

.layout {
  margin: 20px;
  margin-top: 60px;
  background: #ffffff;
  gap: 12px;
}

.head {
  color: #3f4254;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  margin: 10px 0;
}

.vertical-line {
  border-right: 1px solid gainsboro;
}

.right-header {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
}

.rightDiv {
  display: flex;
  gap: 8px;
}

.selectClass {
  font-size: 12px !important;
  margin: 7px 0px;
  background-color: #f2f4ff;
  border-radius: 5px;
  width: 140px;
  text-align: center;
}

.report {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f2f4ff;
  border-radius: 5px;
  height: 25.5px;
  text-align: center;
  padding: 0 20px;
  margin: 7px 0;
}
.report p {
  font-size: 12px;
  color: #959cbd;
  text-align: center;
}
.report div {
  width: 18px;
  height: 18px;
  background-image: url('report-download.svg');
  background-repeat: no-repeat;
  background-position: center;
}

.tabs {
  background-color: #ffffff;
  margin: 20px;
  margin-top: 60px;
  margin-left: 20px !important;
  margin-right: 20px !important;
  padding: 10px;
  margin-bottom: 70px;
}

.headerTab {
  padding: 20px;
  padding-top: 0px;
}

::ng-deep .mdc-tab__text-label {
  font-size: 16px !important;
  letter-spacing: 0px;
  color: #181c32 !important;
  font-family: "Poppins", sans-serif;
}

.tab-label:hover {
  color: #3e97ff;
}

.tab-active {
  border-bottom: 2px solid #3e97ff;
}
.tab-active .tab-label {
  color: #3e97ff;
}

.redFlag {
  color: #3e97ff;
  border-bottom: 2px solid #3e97ff;
}
.redFlag .tab-label {
  color: #3e97ff;
}

.toolbar {
  background-color: #ffffff;
}
.toolbar mat-toolbar-row {
  padding: 0px;
}
.toolbar nav a {
  padding: 0px 8px;
}
.toolbar nav .history {
  margin-left: 4px;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.searchFlag {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.searchFlag .search {
  width: 30%;
}
.searchFlag .search .searchText input,
.searchFlag .search .searchText input::placeholder {
  font-size: 12px;
  color: #959cbd;
  font-family: "Poppins";
}
.searchFlag .search .searchText input {
  border-color: #f1f1f2;
  box-shadow: none !important;
}
.searchFlag .flag {
  display: grid;
  justify-content: left;
  margin-left: 18px;
}

::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {
  width: 6px !important;
}

.logClass {
  font-size: 12px !important;
  padding: 5px 10px !important;
  width: 220px;
  text-align: center;
  background-repeat: no-repeat;
  background-position: calc(100% - 3px), calc(0% + 8px);
  background-size: 18px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
  border-radius: 5px;
}

.flagClass {
  font-size: 12px !important;
  padding: 5px 0px !important;
  width: 150px;
  text-align: center;
  background-repeat: no-repeat;
  background-position: calc(100% - 3px), calc(0% + 8px);
  background-size: 18px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
  border-radius: 5px;
}

.option {
  font-size: 12px !important;
  padding-left: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.option:active {
  color: #3e97ff !important;
}
.option:hover {
  color: #3e97ff;
}
.option span {
  padding-left: 8px;
}
.option img {
  width: 17px;
}

.redflagClass {
  font-size: 12px !important;
  padding: 10px 12px !important;
  text-align: center;
  background-size: 25px 15px !important;
  --bs-form-select-bg-img: url('flag-dropdown.svg'),
    url('flag-red.svg');
  background-position: right, left;
  background-size: 30px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
}

::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

.mat-icon {
  height: 30px;
}
.mat-icon img {
  width: 17px;
}

.custom-mat-form-field {
  width: 50%;
  height: 50px;
}

.input {
  height: 50%;
  margin: 7px 0px;
  width: 120px;
  background: #f2f4ff;
  border: none;
  font-size: 12px;
  color: #959cbd;
  border-radius: 5px;
}
.input:focus {
  outline: none;
}

.input::placeholder {
  color: #959cbd;
  padding-left: 10px;
}

::ng-deep .ngx-pagination li {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  border-radius: 5px !important;
  margin: 0px 15px;
}
::ng-deep .ngx-pagination li a {
  color: #959cbd !important;
}

::ng-deep .ngx-pagination li :hover {
  border-radius: 5px !important;
  color: #ffffff !important;
  background-color: #3e97ff !important;
}

::ng-deep .ngx-pagination li:not(:last-child) {
  background-color: #f1f1f2 !important;
}

::ng-deep .ngx-pagination li.current {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background-color: #3e97ff !important;
  color: #ffffff !important;
  cursor: pointer;
}

.date-pickder {
  height: 25px;
}

.dateClass {
  width: 180px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  color: #959cbd;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: 155px;
  background-color: #f2f4ff;
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 5px;
  padding-right: 25px;
  margin-left: 8px;
}

::ng-deep .mat-form-field-type-mat-date-range-input .mat-form-field-infix {
  display: flex;
}

::ng-deep .mat-date-range-input-start-wrapper {
  width: 32%;
}

::ng-deep .md-drppicker.ltr {
  position: fixed;
  color: #181c32;
  padding: 10px;
}

::ng-deep .md-drppicker .ranges ul li button.active {
  background-color: #3e97ff !important;
  border-radius: 5px;
}

::ng-deep .md-drppicker td.active,
.md-drppicker td.active:hover {
  background-color: #3e97ff !important;
}

::ng-deep .md-drppicker .calendar th span,
.md-drppicker .calendar td span {
  color: #181c32 !important;
}

::ng-deep .md-drppicker th.month {
  color: #181c32;
}

::ng-deep .buttons_input .btn {
  background-color: #3e97ff !important;
}
::ng-deep .buttons_input .btn-default {
  background-color: #dcdcdc !important;
  margin-right: 15px;
}

.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker {
  height: 300px;
  overflow: auto;
  top: 125px !important;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li {
  border-radius: 5px;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li:hover {
  background-color: #3e97ff;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li button:hover {
  color: #ffffff;
}

::ng-deep .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {
  color: #3e97ff !important;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {
  margin: 0px !important;
}

::ng-deep .mat-mdc-tab-link-container {
  overflow: auto !important;
}

.tab-navbar {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

@media (max-width: 1024px) {
  .tab-navbar {
    flex-direction: column;
  }
}
@media (max-width: 540px) {
  .rightDiv {
    overflow-x: auto;
  }
  .search {
    width: 100% !important;
  }
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 60px !important;
    top: 160px !important;
  }
}
@media (width: 540px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 200px !important;
  }
  .rightHeader {
    justify-content: center !important;
  }
}
@media (max-width: 768px) {
  .layout {
    margin-top: 95px;
  }
  .right-header {
    padding: 0 10px;
  }
}
@media (max-width: 290px) {
  .toolbar {
    overflow-x: auto;
  }
  .searchFlag {
    display: block;
  }
  .search {
    padding: 15px 0px;
  }
  .flag {
    display: block !important;
    text-align: right;
  }
}
@media (min-width: 769px) and (max-width: 830px) {
  .rightDiv {
    overflow-x: auto;
  }
}
@media (min-width: 700px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: calc(100% - 630px) !important;
  }
}
@media (width: 280px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 9px !important;
  }
}
@media screen and (max-width: 767px) {
  ::ng-deep .mat-mdc-tab-link-container {
    overflow: auto !important;
  }
  ::ng-deep .mat-mdc-tab-nav-bar {
    width: 100% !important;
  }
}
.tabs {
  background-color: #ffffff;
  margin: 20px;
  margin-left: 20px !important;
  margin-right: 20px !important;
  padding: 10px;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.hideButton {
  z-index: -1;
}

::ng-deep .mat-mdc-menu-content :hover,
.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text :hover {
  color: #3e97ff !important;
  background-color: #f2f4ff;
}

::ng-deep .mdc-tab__text-label {
  font-size: 16px !important;
  letter-spacing: 0px;
  color: #181c32 !important;
  font-family: "Poppins", sans-serif;
}

.tab-label:hover {
  color: #3e97ff;
}

.topClass {
  position: fixed;
  z-index: 10;
  top: 80px;
  width: 100%;
}

.layout-header {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  overflow-y: hidden;
  margin: 0px !important;
  overflow-x: hidden;
}
.layout-header .back-icon {
  margin-top: 12px;
  margin-left: 10px;
}

.tab-header {
  border-bottom: none;
  height: 70px;
  padding-left: 10px;
}
.tab-header a {
  padding: 0px;
  width: 0px;
  text-decoration: none;
}
.tab-header a:hover {
  color: #3e97ff;
}
.tab-header .tab-active {
  border-bottom: 2px solid #3e97ff;
}
.tab-header .tab-active .tab-label {
  color: #3e97ff;
}
.tab-header .mat-tab-link {
  min-width: 110px !important;
  margin-top: 10px;
  padding: 0;
  font-size: 18px;
  font-weight: 700;
  opacity: 0.5;
}

.layout-panel {
  height: calc(100vh - 170px);
  overflow: auto;
}
.layout-panel > div {
  margin: 20px;
  padding: 0 10px;
  background: #ffffff;
}
@media (max-width: 576px) {
  .layout-panel {
    height: calc(100vh - 207px);
  }
}

.tab-body {
  top: 20px;
}

.material-icons {
  vertical-align: middle;
  margin-left: 25px;
  font-size: 30px;
}

.create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
  margin: 0px !important;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 9;
  padding-left: 2px;
}
.create-action img {
  margin-left: 0px !important;
  width: 12px;
  margin-bottom: 1px !important;
  z-index: 9;
  position: relative;
}

.create-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.create-action:hover::before {
  left: 0;
}

.delete-action {
  width: 100%;
  background: #ff4b55;
}
.delete-action img {
  width: 15px;
  height: 15px;
  transform: translateY(-1.5px);
  margin: 0;
}
.delete-action:hover, .delete-action:focus, .delete-action:active {
  background: #ff4b55;
  color: #ffffff;
  border: 1px solid #ff4b55;
}

.deletecount {
  width: 100%;
  text-align: center;
  color: #ff4b55;
  background-color: #fff5f8;
  padding: 6px 12px;
  border-radius: 5px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 13px;
}

.searchFlag {
  gap: 12px;
  padding-right: 10px;
}

.search {
  width: 100% !important;
}

.buttonsClass {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.rightHeader {
  justify-content: flex-end;
}

.vendor {
  margin-right: 7px;
}

@media (max-width: 768px) {
  .layout {
    margin-top: 95px !important;
  }
}
@media (max-width: 560px) {
  .layout-header {
    flex-direction: column;
  }
}
@media (max-width: 452px) {
  .searchFlag {
    flex-direction: column;
  }
  .buttonsClass,
  .create-action {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/bas/users/users-layout/users-layout.component.scss","webpack://./src/app/bas/associates/associate-layout-v2/associate-layout-v2.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;ADlQA,iDAAA;AAEA;EACE,gBAAA;ACoQF;;ADjQA;EACE,qBAAA;ACoQF;;ADjQA;EACE,sBAAA;ACoQF;;AD5PA;EACE,sBAAA;AC+PF;;AD5PA;EACE,aAAA;AC+PF;;AD5PA;;;EAGE,oCAAA;EACA,gCAAA;AC+PF;;AD5PA;EACE,oCAAA;AC+PF;;AD5PA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;ACVJ;ADkBM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AChBR;ADoBI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;ACoDF;;ADmBA,mCAAA;AA8BA;EACE,wBAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,uBAAA;AC7CF;;ADiDE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AC9CJ;ADgDI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;AClDN;AD4CM;EACE,yBAAA;AC1CR;ADkDI;EACE,8BAAA;AChDN;ADmDI;EACE,eAAA;ACjDN;ADoDI;EACE,0CAAA;EACA,4BAAA;AClDN;ADoDM;EACE,iBAAA;EACA,sBAAA;AClDR;ADqDM;EACE,wBAAA;ACnDR;;ADyDA;;EAEE,sBAAA;EACA,gBAAA;ACtDF;;ADyDA;EACE,mBAAA;EACA,kBAAA;ACtDF;;ADyDA;EACE,yDAAA;ACtDF;;ADyDA;EACE,aAAA;ACtDF;;AD0DE;EACE,qBAAA;ACvDJ;AD0DE;EACE,QAAA;ACxDJ;;AD6DA,kBAAA;AAEA;EACE,mBAAA;AC3DF;AD6DE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC3DJ;;AD+DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AC5DF;AD8DE;EACE,YAAA;AC5DJ;AD+DE;EACE,0BAAA;AC7DJ;ADgEE;EACE,qBAAA;AC9DJ;ADiEE;EACE,YAAA;AC/DJ;ADkEE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AChEJ;ADmEE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACjEJ;ADmEI;EACE,yBAAA;ACjEN;ADqEI;EACE,qBAAA;ACnEN;ADsEI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACpEN;ADuEI;EACE,8BAAA;ACrEN;ADwEI;EACE,6BAAA;ACtEN;ADyEI;EACE,WAAA;ACvEN;AD2EE;EACE,eAAA;ACzEJ;AD6EI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC3EN;AD8EI;EACE,wBAAA;AC5EN;;ADiFA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;AChFF;;ADmFA;EACE,iCAAA;AChFF;ADkFE;EACE,uCAAA;AChFJ;;ADoFA;EACE,yCAAA;ACjFF;ADmFE;EACE,+CAAA;ACjFJ;;ACpgBA;EACE,gBAAA;ADugBF;ACrgBE;EACE,uBAAA;ADugBJ;;ACngBA;EACE,YAAA;ADsgBF;ACpgBE;EACE,aAAA;EACA,sBAAA;ADsgBJ;ACngBE;EACE,YAAA;ADqgBJ;;ACjgBA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;ADogBF;;ACjgBA;EACE,uBAAA;ADogBF;;ACjgBA;EACE,wBAAA;ADogBF;;ACjgBA;EACE,wBAAA;ADogBF;;ACjgBA;;EAEE,cFHQ;ACugBV;;ACjgBA;;EAEE,cFRQ;AC4gBV;;ACjgBA;EACE,cFUS;EETT,kCF6Ba;EE5Bb,gBF+BO;ACqeT;;ACjgBA;EACE,wBAAA;ADogBF;;ACjgBA;EACE,kCFoBa;EEnBb,gBFwBY;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBE9BE;EFyIF,eE3IE;EF4IF,gBE3IE;EF4IF,YE9IE;EF+IF,gBEhJE;EFiJF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EE9IA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADohBF;ADxYE;EACE,mBAAA;AC0YJ;ADvYE;EACE,aAAA;ACyYJ;ADtYE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACmYJ;AD7XE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;AC6XJ;ACliBE;EACE,cFJI;EEKJ,kBAAA;EACA,cAAA;EACA,iBAAA;ADoiBJ;ACjiBE;EAEE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;ADkiBJ;;AC9hBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;ADiiBF;;AC9hBA;EACE,OAAA;ADiiBF;;AC7hBA;EACE,uBAAA;ADgiBF;;AC5hBE;EACE,eAAA;AD+hBJ;;AC1hBA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AD6hBF;;AC1hBA;EACE,2BAAA;AD6hBF;;AC1hBA;EACE,WAAA;EACA,iBAAA;AD6hBF;;AC1hBA;EACE,4BAAA;AD6hBF;;AC1hBA;EACE,yBFpEM;EEqEN,kBAAA;EACA,sBAAA;EACA,kBAAA;AD6hBF;;AC1hBA;EACE,YAAA;EACA,gBAAA;EACA,mBF7EM;EE8EN,SAAA;AD6hBF;;AC1hBA;EACE,cFjFM;EEkFN,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AD6hBF;;AC1hBA;EACE,iCAAA;AD6hBF;;AC1hBA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AD6hBF;;AC1hBA;EACE,aAAA;EACA,QAAA;AD6hBF;;AC1hBA;EACE,0BAAA;EACA,eAAA;EAIA,yBFjJc;EEkJd,kBAAA;EACA,YAAA;EACA,kBAAA;AD0hBF;;ACvhBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBF3Jc;EE4Jd,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AD0hBF;ACxhBE;EACE,eAAA;EACA,cFhJO;EEiJP,kBAAA;AD0hBJ;ACthBE;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,2BAAA;ADwhBJ;;AClhBA;EACE,yBFlJM;EEmJN,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;ADqhBF;;AClhBA;EACE,aAAA;EACA,gBAAA;ADqhBF;;AClhBA;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCF/Ja;ACorBf;;ACjhBE;EACE,cF9MM;ACkuBV;;AChhBA;EAKE,gCAAA;AD+gBF;ACnhBE;EACE,cFpNM;ACyuBV;;AC/gBA;EAKE,cF/NQ;EEgOR,gCAAA;AD8gBF;ACnhBE;EACE,cF5NM;ACivBV;;AC9gBA;EAeE,yBF7MM;ACgtBR;ACjhBE;EACE,YAAA;ADmhBJ;AC/gBI;EACE,gBAAA;ADihBN;AC9gBI;EACE,gBAAA;ADghBN;;ACxgBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AD2gBF;ACzgBE;EACE,YAAA;AD2gBJ;;ACvgBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AD0gBF;;ACvgBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AD0gBF;ACxgBE;EACE,UAAA;AD0gBJ;ACtgBM;;EAEE,eAAA;EACA,cF/PG;EEgQH,sBAAA;ADwgBR;ACrgBM;EACE,qBFvQG;EEwQH,2BAAA;ADugBR;AClgBE;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;ADogBJ;;AChgBA;EACE,qBAAA;ADmgBF;;AChgBA;EACE,0BAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,qDAAA;EACA,qBAAA;EACA,yBFjTc;EEkTd,YAAA;EACA,cF/RS;EEgST,2BAAA;EACA,kBAAA;ADmgBF;;AChgBA;EACE,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EAGA,4BAAA;EAEA,qDAAA;EACA,qBAAA;EACA,yBFnUc;EEoUd,YAAA;EACA,cFjTS;EEkTT,2BAAA;EACA,kBAAA;ADggBF;;AC7fA;EACE,0BAAA;EACA,kBAAA;EACA,kCFrSa;EEsSb,gBFnSO;ACmyBT;AC9fE;EACE,yBAAA;ADggBJ;AC7fE;EACE,cFvVM;ACs1BV;AC5fE;EACE,iBAAA;AD8fJ;AC3fE;EACE,WAAA;AD6fJ;;ACzfA;EACE,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,qCAAA;EACA;uBAAA;EAEA,gCAAA;EACA,qBAAA;EACA,yBF1Wc;EE2Wd,YAAA;EACA,cFxVS;EEyVT,2BAAA;AD4fF;;ACzfA;EACE,wBAAA;AD4fF;;ACzfA;EACE,YAAA;AD4fF;AC1fE;EACE,WAAA;AD4fJ;;ACxfA;EACE,UAAA;EACA,YAAA;AD2fF;;ACxfA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBFrYc;EEsYd,YAAA;EACA,eAAA;EACA,cFpXS;EEqXT,kBAAA;AD2fF;ACzfE;EACE,aAAA;AD2fJ;;ACvfA;EACE,cF7XS;EE8XT,kBAAA;AD0fF;;ACvfA;EACE,kCF9Wa;EE+Wb,gBF5WO;EE6WP,6BAAA;EACA,gBAAA;AD0fF;ACxfE;EACE,yBAAA;AD0fJ;;ACtfA;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;ADyfF;;ACtfA;EACE,oCAAA;ADyfF;;ACtfA;EACE,kCFnYa;EEoYb,gBFjYO;EEkYP,oCAAA;EACA,yBAAA;EACA,eAAA;ADyfF;;ACtfA;EACE,YAAA;ADyfF;;ACtfA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cFvaS;EEwaT,kCFpZa;EEqZb,gBFlZO;EEmZP,eAAA;EACA,0CAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBFlcc;EEmcd,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ADyfF;;ACtfA;EACE,aAAA;ADyfF;;ACtfA;EACE,UAAA;ADyfF;;ACtfA;EAEE,eAAA;EACA,cFvcK;EEwcL,aAAA;ADwfF;;ACrfA;EACE,oCAAA;EACA,kBAAA;ADwfF;;ACrfA;;EAEE,oCAAA;ADwfF;;ACrfA;;EAEE,yBAAA;ADwfF;;ACrfA;EACE,cF3dK;ACm9BP;;ACpfE;EACE,oCAAA;ADufJ;ACpfE;EACE,oCAAA;EACA,kBAAA;ADsfJ;;ACjfE;EACE,aAAA;EACA,cAAA;EACA,qBAAA;ADofJ;AChfQ;EACE,kBAAA;ADkfV;AChfU;EACE,yBFtgBF;ACw/BV;AC9eY;EACE,cFteN;ACs9BR;;ACveA;EACE,yBAAA;EACA,kCF5ea;EE6eb,gBF1eO;ACo9BT;;ACveA;EACE,sBAAA;AD0eF;;ACveA;EACE,yBAAA;AD0eF;;ACveA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AD0eF;;ACveA;EACE;IACE,sBAAA;ED0eF;AACF;ACveA;EACE;IACE,gBAAA;EDyeF;ECteA;IACE,sBAAA;EDweF;ECreA;IACE,qBAAA;IACA,qBAAA;EDueF;AACF;ACpeA;EACE;IACE,sBAAA;EDseF;ECneA;IACE,kCAAA;EDqeF;AACF;ACleA;EACE;IACE,gBAAA;EDoeF;ECleA;IACE,eAAA;EDoeF;AACF;ACjeA;EACE;IACE,gBAAA;EDmeF;ECheA;IACE,cAAA;EDkeF;EC/dA;IACE,iBAAA;EDieF;EC9dA;IACE,yBAAA;IACA,iBAAA;EDgeF;AACF;AC7dA;EACE;IACE,gBAAA;ED+dF;AACF;AC5dA;EACE;IACE,mCAAA;ED8dF;AACF;AC3dA;EACE;IACE,oBAAA;ED6dF;AACF;AC1dA;EACE;IACE,yBAAA;ED4dF;ECzdA;IACE,sBAAA;ED2dF;AACF;AA5nCA;EACE,yBDyEM;ECxEN,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;AA8nCF;;AA3nCA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA8nCF;AA5nCE;EACE,YAAA;AA8nCJ;;AA1nCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA6nCF;;AA1nCA;EACE,WAAA;AA6nCF;;AAxnCE;;EACE,yBAAA;EACA,yBDMY;ACsnChB;;AAxnCA;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCDsCa;ACqlCf;;AAvnCE;EACE,cDTM;ACmoCV;;AAtnCA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAynCF;;AAtnCA;EACE,aAAA;EACA,8BAAA;EACA,yBDcM;ECbN,kBAAA;EACA,sBAAA;EACA,kBAAA;AAynCF;AAvnCE;EACE,gBAAA;EACA,iBAAA;AAynCJ;;AArnCA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AAwnCF;AAtnCE;EACE,YAAA;EACA,UAAA;EACA,qBAAA;AAwnCJ;AAtnCI;EACE,cD7CI;ACqqCV;AApnCE;EAKE,gCAAA;AAknCJ;AAtnCI;EACE,cDnDI;AC2qCV;AAlnCE;EACE,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBDhBM;ECiBN,YAAA;AAonCJ;;AAhnCA;EACE,2BAAA;EACA,cAAA;AAmnCF;AAjnCE;EACE,YAAA;EACA,eAAA;EACA,mBDrCI;ACwpCR;AAhnCE;EAVF;IAWI,2BAAA;EAmnCF;AACF;;AAhnCA;EACE,SAAA;AAmnCF;;AAhnCA;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;AAmnCF;;AAhnCA;EACE,kCDnDa;ECoDb,gBD/CY;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBCyCE;EDkEF,eCpEE;EDqEF,gBCpEE;EDqEF,YCvEE;EDwEF,gBCzEE;ED0EF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;ECvEA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,sBAAA;AAmoCF;AD9jCE;EACE,mBAAA;ACgkCJ;AD7jCE;EACE,aAAA;AC+jCJ;AD5jCE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACyjCJ;ADnjCE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;ACmjCJ;AAjpCE;EACE,cD3EI;EC4EJ,kBAAA;EACA,UAAA;EACA,iBAAA;AAmpCJ;AAhpCE;EACE,2BAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AAkpCJ;;AA9oCA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AAipCF;;AA9oCA;EACE,OAAA;AAipCF;;AA9oCA;EACE,WAAA;EACA,mBD1IO;AC2xCT;AA/oCE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;AAipCJ;AD/lCE;EAGE,mBArMK;EAsML,cAvKI;EAwKJ,yBAAA;AC+lCJ;;AAhpCA;EACE,WAAA;EACA,kBAAA;EACA,cDzJO;EC0JP,yBDxJa;ECyJb,iBAAA;EACA,kBAAA;EACA,kCDzHa;EC0Hb,gBAAA;EACA,eAAA;AAmpCF;;AAhpCA;EACE,SAAA;EACA,mBAAA;AAmpCF;;AAhpCA;EACE,sBAAA;AAmpCF;;AAhpCA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAmpCF;;AAhpCA;EACE,yBAAA;AAmpCF;;AAhpCA;EACE,iBAAA;AAmpCF;;AAhpCA;EACE;IACE,2BAAA;EAmpCF;AACF;AAhpCA;EACE;IACE,sBAAA;EAkpCF;AACF;AA/oCA;EACE;IACE,sBAAA;EAipCF;EA9oCA;;IAEE,WAAA;EAgpCF;AACF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"../../associates/associate-layout-v2/associate-layout-v2.component.scss\";\n\n.tabs {\n  background-color: $white;\n  margin: 20px;\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n  padding: 10px;\n}\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.hideButton {\n  z-index: -1;\n}\n\n::ng-deep .mat-mdc-menu-content,\n.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {\n  :hover {\n    color: $primary !important;\n    background-color: $primary-light;\n  }\n}\n\n::ng-deep .mdc-tab__text-label {\n  font-size: 16px !important;\n  letter-spacing: 0px;\n  color: $dark !important;\n  font-family: $primary-font;\n}\n\n.tab-label {\n  &:hover {\n    color: $primary;\n  }\n}\n\n.topClass {\n  position: fixed;\n  z-index: 10;\n  top: 80px;\n  width: 100%;\n}\n\n.layout-header {\n  display: flex;\n  justify-content: space-between;\n  background-color: $white;\n  overflow-y: hidden;\n  margin: 0px !important;\n  overflow-x: hidden;\n\n  .back-icon {\n    margin-top: 12px;\n    margin-left: 10px;\n  }\n}\n\n.tab-header {\n  border-bottom: none;\n  height: 70px;\n  padding-left: 10px;\n\n  a {\n    padding: 0px;\n    width: 0px;\n    text-decoration: none;\n\n    &:hover {\n      color: $primary;\n    }\n  }\n\n  .tab-active {\n    .tab-label {\n      color: $primary;\n    }\n\n    border-bottom: 2px solid $primary;\n  }\n\n  .mat-tab-link {\n    min-width: 110px !important;\n    margin-top: 10px;\n    padding: 0;\n    font-size: 18px;\n    font-weight: $ft-bold;\n    opacity: 0.5;\n  }\n}\n\n.layout-panel {\n  height: calc(100vh - 170px);\n  overflow: auto;\n\n  >div {\n    margin: 20px;\n    padding: 0 10px;\n    background: $white;\n  }\n\n  @media (max-width: 576px) {\n    height: calc(100vh - 207px);\n  }\n}\n\n.tab-body {\n  top: 20px;\n}\n\n.material-icons {\n  vertical-align: middle;\n  margin-left: 25px;\n  font-size: 30px;\n}\n\n.create-action {\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n  margin: 0px !important;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n\n  img {\n    margin-left: 0px !important;\n    width: 12px;\n    margin-bottom: 1px !important;\n    z-index: 9;\n    position: relative;\n  }\n}\n\n.create-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.create-action:hover::before {\n  left: 0;\n}\n\n.delete-action {\n  width: 100%;\n  background: $danger;\n\n  img {\n    width: 15px;\n    height: 15px;\n    transform: translateY(-1.5px);\n    margin: 0;\n  }\n\n  @include no-transition($danger, $white);\n}\n\n.deletecount {\n  width: 100%;\n  text-align: center;\n  color: $danger;\n  background-color: $danger-light;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-family: $primary-font;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.searchFlag {\n  gap: 12px;\n  padding-right: 10px;\n}\n\n.search {\n  width: 100% !important;\n}\n\n.buttonsClass {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.rightHeader {\n  justify-content: flex-end;\n}\n\n.vendor {\n  margin-right: 7px;\n}\n\n@media (max-width: 768px) {\n  .layout {\n    margin-top: 95px !important;\n  }\n}\n\n@media (max-width: 560px) {\n  .layout-header {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 452px) {\n  .searchFlag {\n    flex-direction: column;\n  }\n\n  .buttonsClass,\n  .create-action {\n    width: 100%;\n  }\n}","@import \"src/assets/styles/global.scss\";\n\n.no-margin {\n  margin-left: 0px;\n\n  mat-select {\n    padding: 3px !important;\n  }\n}\n\n.inactiveFlag {\n  padding: 0px;\n\n  form {\n    display: flex;\n    justify-content: right;\n  }\n\n  .searchText {\n    width: 210px;\n  }\n}\n\n.tab-header {\n  border-bottom: none;\n  height: 70px;\n  padding-left: 10px;\n}\n\n::ng-deep .main-content .content {\n  padding: 0px !important;\n}\n\n::ng-deep .mat-ripple .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-disabled {\n  display: none !important;\n}\n\n::ng-deep .mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {\n  display: none !important;\n}\n\n::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-minimal::after,\n.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-minimal::after {\n  color: $primary;\n}\n\n::ng-deep .mdc-list-item--selected .mdc-list-item__primary-text,\n.mdc-list-item--activated .mdc-list-item__primary-text {\n  color: $primary;\n}\n\n::ng-deep .mat-mdc-select-value-text {\n  color: $gray-500;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n}\n\n::ng-deep .mat-mdc-select-arrow-wrapper {\n  display: none !important;\n}\n\n.create-action {\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  margin: 0px 7px !important;\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 10000;\n    padding-left: 2px;\n  }\n\n  img {\n    // margin-left: 7px;\n    position: relative;\n    z-index: 10000;\n    margin-bottom: 3px;\n    width: 12px;\n  }\n}\n\n.create-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.create-action:hover::before {\n  left: 0;\n}\n\n// .flexclass {\n::ng-deep .mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {\n  flex-grow: 0 !important;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-link {\n    padding: 0 10px;\n  }\n}\n\n// }\n.topClass {\n  position: fixed;\n  z-index: 10;\n  top: 80px;\n  min-height: 40px;\n  width: 100%;\n}\n\n.download {\n  margin-left: 8px !important;\n}\n\n.allFlags {\n  width: 24px;\n  margin-left: -3px;\n}\n\n.siteClass {\n  margin-left: 10px !important;\n}\n\n.layout-header {\n  background-color: $white;\n  overflow-y: hidden;\n  margin: 0px !important;\n  overflow-x: hidden;\n}\n\n.layout {\n  margin: 20px;\n  margin-top: 60px;\n  background: $white;\n  gap: 12px\n}\n\n.head {\n  color: $black;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 20px;\n  margin: 10px 0;\n}\n\n.vertical-line {\n  border-right: 1px solid gainsboro;\n}\n\n.right-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 20px;\n}\n\n.rightDiv {\n  display: flex;\n  gap: 8px;\n}\n\n.selectClass {\n  font-size: 12px !important;\n  margin: 7px 0px;\n  // background-repeat: no-repeat;\n  // background-position-x: 96%;\n  // background-position-y: center;\n  background-color: $primary-light;\n  border-radius: 5px;\n  width: 140px;\n  text-align: center;\n}\n\n.report {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: $primary-light;\n  border-radius: 5px;\n  height: 25.5px;\n  text-align: center;\n  padding: 0 20px;\n  margin: 7px 0;\n\n  p {\n    font-size: 12px;\n    color: $gray-500;\n    text-align: center;\n\n  }\n\n  div {\n    width: 18px;\n    height: 18px;\n    background-image: url(\"../../../../assets/images/report-download.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n\n}\n\n.tabs {\n  background-color: $white;\n  margin: 20px;\n  margin-top: 60px;\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n  padding: 10px;\n  margin-bottom: 70px;\n}\n\n.headerTab {\n  padding: 20px;\n  padding-top: 0px;\n}\n\n::ng-deep .mdc-tab__text-label {\n  font-size: 16px !important;\n  letter-spacing: 0px;\n  color: $dark !important;\n  font-family: $primary-font;\n}\n\n.tab-label {\n  &:hover {\n    color: $primary;\n  }\n}\n\n.tab-active {\n  .tab-label {\n    color: $primary;\n  }\n\n  border-bottom: 2px solid $primary;\n}\n\n.redFlag {\n  .tab-label {\n    color: $primary;\n  }\n\n  color: $primary;\n  border-bottom: 2px solid $primary;\n}\n\n.toolbar {\n  mat-toolbar-row {\n    padding: 0px;\n  }\n\n  nav {\n    a {\n      padding: 0px 8px;\n    }\n\n    .history {\n      margin-left: 4px;\n    }\n  }\n\n  background-color: $white;\n}\n\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.searchFlag {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n\n  .search {\n    width: 30%;\n\n    .searchText {\n\n      input,\n      input::placeholder {\n        font-size: 12px;\n        color: $gray-500;\n        font-family: \"Poppins\";\n      }\n\n      input {\n        border-color: $gray-200;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  .flag {\n    display: grid;\n    justify-content: left;\n    margin-left: 18px;\n  }\n}\n\n::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {\n  width: 6px !important;\n}\n\n.logClass {\n  font-size: 12px !important;\n  padding: 5px 10px !important;\n  width: 220px;\n  text-align: center;\n  background-repeat: no-repeat;\n  background-position: calc(100% + -3px), calc(0% + 8px);\n  background-size: 18px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n  border-radius: 5px;\n}\n\n.flagClass {\n  font-size: 12px !important;\n  padding: 5px 0px !important;\n  width: 150px;\n  text-align: center;\n  // background-size: 25px !important;\n  // background-image: url(\"../../../../assets/images/flag-dropdown.svg\"),url(\"../../../../assets/images/flag.svg\");\n  background-repeat: no-repeat;\n  // background-position: right, left;\n  background-position: calc(100% + -3px), calc(0% + 8px);\n  background-size: 18px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n  border-radius: 5px;\n}\n\n.option {\n  font-size: 12px !important;\n  padding-left: 10px;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n\n  &:active {\n    color: $primary !important;\n  }\n\n  &:hover {\n    color: $primary;\n  }\n\n  span {\n    padding-left: 8px;\n  }\n\n  img {\n    width: 17px;\n  }\n}\n\n.redflagClass {\n  font-size: 12px !important;\n  padding: 10px 12px !important;\n  text-align: center;\n  background-size: 25px 15px !important;\n  --bs-form-select-bg-img: url(\"../../../../assets/images/flag-dropdown.svg\"),\n    url(\"../../../../assets/images/flag-red.svg\");\n  background-position: right, left;\n  background-size: 30px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n.mat-icon {\n  height: 30px;\n\n  img {\n    width: 17px;\n  }\n}\n\n.custom-mat-form-field {\n  width: 50%;\n  height: 50px;\n}\n\n.input {\n  height: 50%;\n  margin: 7px 0px;\n  width: 120px;\n  background: $primary-light;\n  border: none;\n  font-size: 12px;\n  color: $gray-500;\n  border-radius: 5px;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.input::placeholder {\n  color: $gray-500;\n  padding-left: 10px;\n}\n\n::ng-deep .ngx-pagination li {\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  border-radius: 5px !important;\n  margin: 0px 15px;\n\n  a {\n    color: $gray-500 !important;\n  }\n}\n\n::ng-deep .ngx-pagination li :hover {\n  border-radius: 5px !important;\n  color: $white !important;\n  background-color: $primary !important;\n}\n\n::ng-deep .ngx-pagination li:not(:last-child) {\n  background-color: $gray-200 !important;\n}\n\n::ng-deep .ngx-pagination li.current {\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  background-color: $primary !important;\n  color: $white !important;\n  cursor: pointer;\n}\n\n.date-pickder {\n  height: 25px;\n}\n\n.dateClass {\n  width: 180px;\n  font-size: 12px;\n  text-align: center;\n  height: 24px;\n  color: $gray-500;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  margin-top: 7px;\n  background-image: url(\"../../../../assets/images/calendar-icon.svg\");\n  background-repeat: no-repeat;\n  background-position: 155px;\n  background-color: $primary-light;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  border-radius: 5px;\n  padding-right: 25px;\n  margin-left: 8px;\n}\n\n::ng-deep .mat-form-field-type-mat-date-range-input .mat-form-field-infix {\n  display: flex;\n}\n\n::ng-deep .mat-date-range-input-start-wrapper {\n  width: 32%;\n}\n\n::ng-deep .md-drppicker.ltr {\n  // left: 0px !important;\n  position: fixed;\n  color: $dark;\n  padding: 10px;\n}\n\n::ng-deep .md-drppicker .ranges ul li button.active {\n  background-color: $primary !important;\n  border-radius: 5px;\n}\n\n::ng-deep .md-drppicker td.active,\n.md-drppicker td.active:hover {\n  background-color: $primary !important;\n}\n\n::ng-deep .md-drppicker .calendar th span,\n.md-drppicker .calendar td span {\n  color: $dark !important;\n}\n\n::ng-deep .md-drppicker th.month {\n  color: $dark;\n}\n\n::ng-deep .buttons_input {\n  .btn {\n    background-color: $primary !important;\n  }\n\n  .btn-default {\n    background-color: #dcdcdc !important;\n    margin-right: 15px;\n  }\n}\n\n.myDatePicker {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    height: 300px;\n    overflow: auto;\n    top: 125px !important;\n\n    .ranges {\n      ul {\n        li {\n          border-radius: 5px;\n\n          &:hover {\n            background-color: $primary;\n          }\n\n          button {\n            &:hover {\n              color: $white;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {\n  color: $primary !important;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n}\n\n::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {\n  margin: 0px !important;\n}\n\n::ng-deep .mat-mdc-tab-link-container {\n  overflow: auto !important;\n}\n\n.tab-navbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n@media (max-width: 1024px) {\n  .tab-navbar {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 540px) {\n  .rightDiv {\n    overflow-x: auto;\n  }\n\n  .search {\n    width: 100% !important;\n  }\n\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 60px !important;\n    top: 160px !important;\n  }\n}\n\n@media (width: 540px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 200px !important;\n  }\n\n  .rightHeader {\n    justify-content: center !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout {\n    margin-top: 95px;\n  }\n  .right-header {\n    padding: 0 10px;\n  }\n}\n\n@media (max-width: 290px) {\n  .toolbar {\n    overflow-x: auto;\n  }\n\n  .searchFlag {\n    display: block;\n  }\n\n  .search {\n    padding: 15px 0px;\n  }\n\n  .flag {\n    display: block !important;\n    text-align: right;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 830px) {\n  .rightDiv {\n    overflow-x: auto;\n  }\n}\n\n@media (min-width: 700px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: calc(100% - 630px) !important;\n  }\n}\n\n@media (width: 280px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 9px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  ::ng-deep .mat-mdc-tab-link-container {\n    overflow: auto !important;\n  }\n\n  ::ng-deep .mat-mdc-tab-nav-bar {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
